import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { PartnerCreditBalance, PartnerCredit, PartnerUser } from '../types/CreditTransfer';

const URL = '/v2';

export interface PartnerCreditTransaction {
  id: number;
  completed: string;
  status: string;
  transferTotal: number;
  partnerName: string;
  voucherCodes: string | null;
}

class PartnerCreditService {
  static get(
    partner: string,
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PartnerCreditBalance>> {
    return axios.get(`${URL}/${partner.toLowerCase()}/${id}`, config);
  }

  static create(
    partner: string,
    data: PartnerCredit,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<PartnerUser>> {
    return axios.post(`${URL}/${partner.toLowerCase()}`, data, config);
  }

  static getTransactionsByFilter(
    config: AxiosRequestConfig
  ): Promise<PagedResponse<PartnerCreditTransaction>> {
    return axios.get(`${URL}/partner-credit-transactions`, config);
  }
}

export { PartnerCreditService };
